import api from "../../../../lib/api";
import { IBranchCreate, IBranchListSearch, IEditBranchPayload } from "../../../../types/master/branchInterface";

export const createBranchApi = async (data: IBranchCreate) => {
  return await api.post(`/branch`, data);
};

export const getBranchListApi = async (data: IBranchListSearch) => {
  return await api.get(`/branch/${data.page}/${data?.pageLimit}?search=${data?.search??""}`)
}

export const getBranchDataByIdApi = async (id: number) => {
  return await api.get(`/branch/${id}`)
}

export const editBranchDataByIdApi = async (payload: IEditBranchPayload) => {
  return await api.put(`/branch/${payload.id}`, payload.data);
};